module.exports = __webpack_public_path__ + "static/media/Lace-parasol-409794-min.6469659a.jpg";